"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Resizer_1 = require("./Resizer");
var CROP_HANDLE_SIZE = 22;
var CROP_HANDLE_WIDTH = 7;
var Xs = ['w', 'e'];
var Ys = ['s', 'n'];
var ROTATION = {
    sw: 0,
    nw: 90,
    ne: 180,
    se: 270,
};
/**
 * @internal
 * Crop handle for DragAndDropHelper
 */
exports.Cropper = {
    onDragStart: function (_a) {
        var editInfo = _a.editInfo;
        return (__assign({}, editInfo));
    },
    onDragging: function (_a, e, base, dx, dy) {
        var _b;
        var editInfo = _a.editInfo, x = _a.x, y = _a.y, options = _a.options;
        _b = Resizer_1.rotateCoordinate(dx, dy, editInfo.angleRad), dx = _b[0], dy = _b[1];
        var widthPx = editInfo.widthPx, heightPx = editInfo.heightPx, leftPercent = editInfo.leftPercent, rightPercent = editInfo.rightPercent, topPercent = editInfo.topPercent, bottomPercent = editInfo.bottomPercent;
        var minWidth = options.minWidth, minHeight = options.minHeight;
        var widthPercent = 1 - leftPercent - rightPercent;
        var heightPercent = 1 - topPercent - bottomPercent;
        if (widthPercent > 0 && heightPercent > 0) {
            var fullWidth = widthPx / widthPercent;
            var fullHeight = heightPx / heightPercent;
            var newLeft = x != 'e'
                ? crop(base.leftPercent, dx, fullWidth, rightPercent, minWidth)
                : leftPercent;
            var newRight = x != 'w'
                ? crop(base.rightPercent, -dx, fullWidth, leftPercent, minWidth)
                : rightPercent;
            var newTop = y != 's'
                ? crop(base.topPercent, dy, fullHeight, bottomPercent, minHeight)
                : topPercent;
            var newBottom = y != 'n'
                ? crop(base.bottomPercent, -dy, fullHeight, topPercent, minHeight)
                : bottomPercent;
            editInfo.leftPercent = newLeft;
            editInfo.rightPercent = newRight;
            editInfo.topPercent = newTop;
            editInfo.bottomPercent = newBottom;
            editInfo.widthPx = fullWidth * (1 - newLeft - newRight);
            editInfo.heightPx = fullHeight * (1 - newTop - newBottom);
            return true;
        }
        else {
            return false;
        }
    },
};
function crop(basePercentage, deltaValue, fullValue, currentPercentage, minValue) {
    var maxValue = fullValue * (1 - currentPercentage) - minValue;
    var newValue = fullValue * basePercentage + deltaValue;
    var validValue = Math.max(Math.min(newValue, maxValue), 0);
    return validValue / fullValue;
}
/**
 * @internal
 * Get HTML for crop elements, including 4 overlays (to show dark shadow), 1 container and 4 crop handles
 */
function getCropHTML() {
    var overlayHTML = {
        tag: 'div',
        style: 'position:absolute;background-color:rgb(0,0,0,0.5);pointer-events:none',
        className: "r_cropO" /* CropOverlay */,
    };
    var containerHTML = {
        tag: 'div',
        style: 'position:absolute;overflow:hidden',
        className: "r_cropC" /* CropContainer */,
        children: [],
    };
    Xs.forEach(function (x) { return Ys.forEach(function (y) { return containerHTML.children.push(getCropHTMLInternal(x, y)); }); });
    return [containerHTML, overlayHTML, overlayHTML, overlayHTML, overlayHTML];
}
exports.getCropHTML = getCropHTML;
function getCropHTMLInternal(x, y) {
    var leftOrRight = x == 'w' ? 'left' : 'right';
    var topOrBottom = y == 'n' ? 'top' : 'bottom';
    var rotation = ROTATION[y + x];
    return {
        tag: 'div',
        className: "r_cropH" /* CropHandle */,
        style: "position:absolute;pointer-events:auto;cursor:" + y + x + "-resize;" + leftOrRight + ":0;" + topOrBottom + ":0;width:" + CROP_HANDLE_SIZE + "px;height:" + CROP_HANDLE_SIZE + "px;transform:rotate(" + rotation + "deg)",
        dataset: { x: x, y: y },
        children: getCropHandleHTML(),
    };
}
function getCropHandleHTML() {
    var result = [];
    [0, 1].forEach(function (layer) {
        return [0, 1].forEach(function (dir) {
            result.push(getCropHandleHTMLInternal(layer, dir));
        });
    });
    return result;
}
function getCropHandleHTMLInternal(layer, dir) {
    var position = dir == 0
        ? "right:" + layer + "px;height:" + (CROP_HANDLE_WIDTH - layer * 2) + "px;"
        : "top:" + layer + "px;width:" + (CROP_HANDLE_WIDTH - layer * 2) + "px;";
    var bgColor = layer == 0 ? 'white' : 'black';
    return {
        tag: 'div',
        style: "position:absolute;left:" + layer + "px;bottom:" + layer + "px;" + position + ";background-color:" + bgColor,
    };
}
//# sourceMappingURL=Cropper.js.map